const DEFAULT_TTL_MS = 3 * 60 * 60 * 1000; // 3 hours

function isExpired(entry) {
  return !entry || !entry.expiresAt || Date.now() > entry.expiresAt;
}

export function readCache({ cacheKey, itemKey }) {
  const str = localStorage.getItem(cacheKey);
  if (!str) return null;

  const parsed = JSON.parse(str);

  if (itemKey) {
    if (!parsed || !parsed[itemKey]) return null;
    const entry = parsed[itemKey];
    if (isExpired(entry)) {
      delete parsed[itemKey];
      localStorage.setItem(cacheKey, JSON.stringify(parsed));
      return null;
    }
    return entry.value;
  } else {
    const entry = parsed;
    if (isExpired(entry)) {
      localStorage.removeItem(cacheKey);
      return null;
    }
    return entry.value;
  }
}

export function writeCache({ cacheKey, itemKey, value, ttl = DEFAULT_TTL_MS } = {}) {
  if (itemKey) {
    const str = localStorage.getItem(cacheKey);
    const parsed = str ? JSON.parse(str) : {};
    parsed[itemKey] = { value, expiresAt: Date.now() + ttl };
    localStorage.setItem(cacheKey, JSON.stringify(parsed));
    return;
  }

  const payload = { value, expiresAt: Date.now() + ttl };
  localStorage.setItem(cacheKey, JSON.stringify(payload));
}

export function readAll({ cacheKey }) {
  const str = localStorage.getItem(cacheKey);
  if (!str) return null;
  const parsed = JSON.parse(str);
  const restored = {};
  let changed = false;
  for (const [itemKey, entry] of Object.entries(parsed)) {
    if (!isExpired(entry) && entry.value) {
      restored[itemKey] = entry.value;
    } else {
      changed = true;
    }
  }
  if (changed) {
    localStorage.setItem(cacheKey, JSON.stringify(restored));
  }
  return Object.keys(restored).length > 0 ? restored : null;
}

export function removeItem({ cacheKey, itemKey }) {
  if (!itemKey) {
    localStorage.removeItem(cacheKey);
    return;
  }
  const str = localStorage.getItem(cacheKey);
  if (!str) return;
  const parsed = JSON.parse(str);
  if (parsed) {
    delete parsed[itemKey];
    localStorage.setItem(cacheKey, JSON.stringify(parsed));
  }
}
